// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"01f57dd6","816":"6db9380f"}[chunkId] + ".chunk.js";
};